var cov_tmgv87zz2 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/LazyList.tsx",
      hash = "ff38d740ead1cc1fc51ead4e26294689b72d47ed",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/LazyList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 16
        }
      },
      "2": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "3": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 52
        }
      },
      "4": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 42,
          column: 5
        }
      },
      "5": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 27
        }
      },
      "6": {
        start: {
          line: 46,
          column: 89
        },
        end: {
          line: 46,
          column: 99
        }
      },
      "7": {
        start: {
          line: 47,
          column: 17
        },
        end: {
          line: 47,
          column: 48
        }
      },
      "8": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 28
        }
      },
      "9": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 55,
          column: 6
        }
      },
      "10": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 48
        }
      },
      "11": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 57,
          column: 44
        }
      },
      "12": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 26
        }
      },
      "13": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 33
        }
      },
      "14": {
        start: {
          line: 71,
          column: 27
        },
        end: {
          line: 71,
          column: 33
        }
      },
      "15": {
        start: {
          line: 72,
          column: 25
        },
        end: {
          line: 72,
          column: 47
        }
      },
      "16": {
        start: {
          line: 73,
          column: 99
        },
        end: {
          line: 73,
          column: 109
        }
      },
      "17": {
        start: {
          line: 74,
          column: 23
        },
        end: {
          line: 74,
          column: 47
        }
      },
      "18": {
        start: {
          line: 75,
          column: 26
        },
        end: {
          line: 75,
          column: 42
        }
      },
      "19": {
        start: {
          line: 76,
          column: 20
        },
        end: {
          line: 76,
          column: 42
        }
      },
      "20": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 78,
          column: 59
        }
      },
      "21": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 90,
          column: 5
        }
      },
      "22": {
        start: {
          line: 81,
          column: 6
        },
        end: {
          line: 81,
          column: 52
        }
      },
      "23": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 34
        }
      },
      "24": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 56
        }
      },
      "25": {
        start: {
          line: 84,
          column: 34
        },
        end: {
          line: 84,
          column: 56
        }
      },
      "26": {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 87,
          column: 80
        }
      },
      "27": {
        start: {
          line: 87,
          column: 46
        },
        end: {
          line: 87,
          column: 80
        }
      },
      "28": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 88,
          column: 52
        }
      },
      "29": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 61
        }
      },
      "30": {
        start: {
          line: 92,
          column: 16
        },
        end: {
          line: 92,
          column: 63
        }
      },
      "31": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 76
        }
      },
      "32": {
        start: {
          line: 93,
          column: 43
        },
        end: {
          line: 93,
          column: 76
        }
      },
      "33": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 28
        }
      },
      "34": {
        start: {
          line: 94,
          column: 19
        },
        end: {
          line: 94,
          column: 28
        }
      },
      "35": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 85
        }
      },
      "36": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 98,
          column: 99
        }
      },
      "37": {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 18
        }
      },
      "38": {
        start: {
          line: 113,
          column: 36
        },
        end: {
          line: 113,
          column: 46
        }
      },
      "39": {
        start: {
          line: 114,
          column: 25
        },
        end: {
          line: 114,
          column: 47
        }
      },
      "40": {
        start: {
          line: 115,
          column: 15
        },
        end: {
          line: 115,
          column: 61
        }
      },
      "41": {
        start: {
          line: 116,
          column: 18
        },
        end: {
          line: 116,
          column: 39
        }
      },
      "42": {
        start: {
          line: 117,
          column: 18
        },
        end: {
          line: 119,
          column: 96
        }
      },
      "43": {
        start: {
          line: 119,
          column: 21
        },
        end: {
          line: 119,
          column: 95
        }
      },
      "44": {
        start: {
          line: 120,
          column: 15
        },
        end: {
          line: 122,
          column: 16
        }
      },
      "45": {
        start: {
          line: 123,
          column: 22
        },
        end: {
          line: 123,
          column: 84
        }
      },
      "46": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 144,
          column: 5
        }
      },
      "47": {
        start: {
          line: 136,
          column: 12
        },
        end: {
          line: 136,
          column: 34
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 3
          }
        },
        loc: {
          start: {
            line: 28,
            column: 46
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 28
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 57
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 39
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 20
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 51,
            column: 2
          },
          end: {
            line: 51,
            column: 3
          }
        },
        loc: {
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 51
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 2
          },
          end: {
            line: 61,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 4
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 70
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 11
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 101
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 119,
            column: 11
          },
          end: {
            line: 119,
            column: 12
          }
        },
        loc: {
          start: {
            line: 119,
            column: 21
          },
          end: {
            line: 119,
            column: 95
          }
        },
        line: 119
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 135,
            column: 15
          },
          end: {
            line: 135,
            column: 16
          }
        },
        loc: {
          start: {
            line: 135,
            column: 21
          },
          end: {
            line: 137,
            column: 11
          }
        },
        line: 135
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 42,
            column: 5
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 8
          },
          end: {
            line: 40,
            column: 24
          }
        }, {
          start: {
            line: 40,
            column: 28
          },
          end: {
            line: 40,
            column: 76
          }
        }],
        line: 40
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 46,
            column: 48
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 46,
            column: 25
          },
          end: {
            line: 46,
            column: 48
          }
        }],
        line: 46
      },
      "3": {
        loc: {
          start: {
            line: 46,
            column: 56
          },
          end: {
            line: 46,
            column: 84
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 46,
            column: 65
          },
          end: {
            line: 46,
            column: 84
          }
        }],
        line: 46
      },
      "4": {
        loc: {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 33
          }
        }, {
          start: {
            line: 71,
            column: 4
          },
          end: {
            line: 71,
            column: 33
          }
        }],
        line: 71
      },
      "5": {
        loc: {
          start: {
            line: 73,
            column: 18
          },
          end: {
            line: 73,
            column: 56
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 73,
            column: 32
          },
          end: {
            line: 73,
            column: 56
          }
        }],
        line: 73
      },
      "6": {
        loc: {
          start: {
            line: 73,
            column: 58
          },
          end: {
            line: 73,
            column: 94
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 73,
            column: 71
          },
          end: {
            line: 73,
            column: 94
          }
        }],
        line: 73
      },
      "7": {
        loc: {
          start: {
            line: 76,
            column: 20
          },
          end: {
            line: 76,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 76,
            column: 37
          },
          end: {
            line: 76,
            column: 38
          }
        }, {
          start: {
            line: 76,
            column: 41
          },
          end: {
            line: 76,
            column: 42
          }
        }],
        line: 76
      },
      "8": {
        loc: {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }, {
          start: {
            line: 80,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        }],
        line: 80
      },
      "9": {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 28
          }
        }, {
          start: {
            line: 80,
            column: 32
          },
          end: {
            line: 80,
            column: 44
          }
        }],
        line: 80
      },
      "10": {
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 56
          }
        }, {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 84,
            column: 56
          }
        }],
        line: 84
      },
      "11": {
        loc: {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 80
          }
        }, {
          start: {
            line: 87,
            column: 6
          },
          end: {
            line: 87,
            column: 80
          }
        }],
        line: 87
      },
      "12": {
        loc: {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 76
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 76
          }
        }, {
          start: {
            line: 93,
            column: 4
          },
          end: {
            line: 93,
            column: 76
          }
        }],
        line: 93
      },
      "13": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 28
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 28
          }
        }],
        line: 94
      },
      "14": {
        loc: {
          start: {
            line: 98,
            column: 59
          },
          end: {
            line: 98,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 98,
            column: 88
          },
          end: {
            line: 98,
            column: 91
          }
        }, {
          start: {
            line: 98,
            column: 94
          },
          end: {
            line: 98,
            column: 96
          }
        }],
        line: 98
      },
      "15": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 106,
            column: 42
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 106,
            column: 19
          },
          end: {
            line: 106,
            column: 42
          }
        }],
        line: 106
      },
      "16": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 108,
            column: 44
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 108,
            column: 20
          },
          end: {
            line: 108,
            column: 44
          }
        }],
        line: 108
      },
      "17": {
        loc: {
          start: {
            line: 111,
            column: 6
          },
          end: {
            line: 111,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 111,
            column: 15
          },
          end: {
            line: 111,
            column: 34
          }
        }],
        line: 111
      },
      "18": {
        loc: {
          start: {
            line: 115,
            column: 40
          },
          end: {
            line: 115,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 40
          },
          end: {
            line: 115,
            column: 46
          }
        }, {
          start: {
            line: 115,
            column: 50
          },
          end: {
            line: 115,
            column: 60
          }
        }],
        line: 115
      },
      "19": {
        loc: {
          start: {
            line: 123,
            column: 22
          },
          end: {
            line: 123,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 123,
            column: 35
          },
          end: {
            line: 123,
            column: 79
          }
        }, {
          start: {
            line: 123,
            column: 82
          },
          end: {
            line: 123,
            column: 84
          }
        }],
        line: 123
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0],
      "16": [0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/LazyList.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Fragment } from 'react';
import { PureComponent } from '../component';
import Scroll from '../Scroll';
import { getKey } from '../utils/uid';
import { setTranslate } from '../utils/dom/translate';
var DefaultProps = (cov_tmgv87zz2.s[0]++, {
  itemsInView: 10,
  lineHeight: 32,
  data: [],
  colNum: 1
});

var LazyList =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LazyList, _PureComponent);

  var _super = _createSuper2(LazyList);

  function LazyList(props) {
    var _this;

    _classCallCheck(this, LazyList);

    cov_tmgv87zz2.f[0]++;
    cov_tmgv87zz2.s[1]++;
    _this = _super.call(this, props);
    _this.optionInner = void 0;
    _this.lastScrollTop = void 0;
    cov_tmgv87zz2.s[2]++;
    _this.state = {
      currentIndex: 0,
      scrollTop: 0,
      fixed: ''
    };
    cov_tmgv87zz2.s[3]++;
    _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LazyList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_tmgv87zz2.f[1]++;
      cov_tmgv87zz2.s[4]++;

      if ((cov_tmgv87zz2.b[1][0]++, !this.props.stay) && (cov_tmgv87zz2.b[1][1]++, prevProps.data.length !== this.props.data.length)) {
        cov_tmgv87zz2.b[0][0]++;
        cov_tmgv87zz2.s[5]++;
        this.resetScrollTop();
      } else {
        cov_tmgv87zz2.b[0][1]++;
      }
    }
  }, {
    key: "getScrollHeight",
    value: function getScrollHeight() {
      cov_tmgv87zz2.f[2]++;

      var _ref = (cov_tmgv87zz2.s[6]++, this.props),
          _ref$lineHeight = _ref.lineHeight,
          lineHeight = _ref$lineHeight === void 0 ? (cov_tmgv87zz2.b[2][0]++, DefaultProps.lineHeight) : _ref$lineHeight,
          data = _ref.data,
          _ref$colNum = _ref.colNum,
          colNum = _ref$colNum === void 0 ? (cov_tmgv87zz2.b[3][0]++, DefaultProps.colNum) : _ref$colNum;

      var rows = (cov_tmgv87zz2.s[7]++, Math.ceil(data.length / colNum));
      cov_tmgv87zz2.s[8]++;
      return rows * lineHeight;
    }
  }, {
    key: "resetScrollTop",
    value: function resetScrollTop() {
      cov_tmgv87zz2.f[3]++;
      cov_tmgv87zz2.s[9]++;
      this.setState({
        currentIndex: 0,
        scrollTop: 0
      });
      cov_tmgv87zz2.s[10]++;
      setTranslate(this.optionInner, '0px', "0px");
      cov_tmgv87zz2.s[11]++;
      this.optionInner.style.marginTop = "0px";
      cov_tmgv87zz2.s[12]++;
      this.lastScrollTop = 0;
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(_x, y, _max, _bar, _v, h, _pixelX, pixelY) {
      cov_tmgv87zz2.f[4]++;
      cov_tmgv87zz2.s[13]++;

      if (!this.optionInner) {
        cov_tmgv87zz2.b[4][0]++;
        cov_tmgv87zz2.s[14]++;
        return;
      } else {
        cov_tmgv87zz2.b[4][1]++;
      }

      var scrollHeight = (cov_tmgv87zz2.s[15]++, this.getScrollHeight());

      var _ref2 = (cov_tmgv87zz2.s[16]++, this.props),
          data = _ref2.data,
          _ref2$itemsInView = _ref2.itemsInView,
          itemsInView = _ref2$itemsInView === void 0 ? (cov_tmgv87zz2.b[5][0]++, DefaultProps.itemsInView) : _ref2$itemsInView,
          _ref2$lineHeight = _ref2.lineHeight,
          lineHeight = _ref2$lineHeight === void 0 ? (cov_tmgv87zz2.b[6][0]++, DefaultProps.lineHeight) : _ref2$lineHeight;

      var fullHeight = (cov_tmgv87zz2.s[17]++, itemsInView * lineHeight);
      var contentHeight = (cov_tmgv87zz2.s[18]++, scrollHeight - h);
      var scrollTop = (cov_tmgv87zz2.s[19]++, h > fullHeight ? (cov_tmgv87zz2.b[7][0]++, 0) : (cov_tmgv87zz2.b[7][1]++, y));
      cov_tmgv87zz2.s[20]++;
      this.optionInner.style.marginTop = "".concat(scrollTop * h, "px");
      cov_tmgv87zz2.s[21]++;

      if ((cov_tmgv87zz2.b[9][0]++, pixelY === undefined) || (cov_tmgv87zz2.b[9][1]++, pixelY === 0)) {
        cov_tmgv87zz2.b[8][0]++;
        cov_tmgv87zz2.s[22]++;
        this.lastScrollTop = scrollTop * contentHeight;
      } else {
        cov_tmgv87zz2.b[8][1]++;
        cov_tmgv87zz2.s[23]++;
        this.lastScrollTop += pixelY;
        cov_tmgv87zz2.s[24]++;

        if (this.lastScrollTop < 0) {
          cov_tmgv87zz2.b[10][0]++;
          cov_tmgv87zz2.s[25]++;
          this.lastScrollTop = 0;
        } else {
          cov_tmgv87zz2.b[10][1]++;
        } // scroll over bottom


        cov_tmgv87zz2.s[26]++;

        if (this.lastScrollTop > contentHeight) {
          cov_tmgv87zz2.b[11][0]++;
          cov_tmgv87zz2.s[27]++;
          this.lastScrollTop = contentHeight;
        } else {
          cov_tmgv87zz2.b[11][1]++;
        }

        cov_tmgv87zz2.s[28]++;
        scrollTop = this.lastScrollTop / contentHeight;
        cov_tmgv87zz2.s[29]++;
        this.optionInner.style.marginTop = "".concat(scrollTop * h, "px");
      }

      var index = (cov_tmgv87zz2.s[30]++, Math.floor(this.lastScrollTop / lineHeight) - 1);
      cov_tmgv87zz2.s[31]++;

      if (data.length - itemsInView < index) {
        cov_tmgv87zz2.b[12][0]++;
        cov_tmgv87zz2.s[32]++;
        index = data.length - itemsInView;
      } else {
        cov_tmgv87zz2.b[12][1]++;
      }

      cov_tmgv87zz2.s[33]++;

      if (index < 0) {
        cov_tmgv87zz2.b[13][0]++;
        cov_tmgv87zz2.s[34]++;
        index = 0;
      } else {
        cov_tmgv87zz2.b[13][1]++;
      }

      cov_tmgv87zz2.s[35]++;
      setTranslate(this.optionInner, '0px', "-".concat(this.lastScrollTop + scrollTop * h, "px"));
      cov_tmgv87zz2.s[36]++;
      this.setState({
        scrollTop: scrollTop,
        currentIndex: index,
        fixed: h < this.getScrollHeight() ? (cov_tmgv87zz2.b[14][0]++, 'y') : (cov_tmgv87zz2.b[14][1]++, '')
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_tmgv87zz2.f[5]++;

      var _ref3 = (cov_tmgv87zz2.s[37]++, this.props),
          className = _ref3.className,
          style = _ref3.style,
          height = _ref3.height,
          _ref3$lineHeight = _ref3.lineHeight,
          lineHeight = _ref3$lineHeight === void 0 ? (cov_tmgv87zz2.b[15][0]++, DefaultProps.lineHeight) : _ref3$lineHeight,
          data = _ref3.data,
          _ref3$itemsInView = _ref3.itemsInView,
          itemsInView = _ref3$itemsInView === void 0 ? (cov_tmgv87zz2.b[16][0]++, DefaultProps.itemsInView) : _ref3$itemsInView,
          renderItem = _ref3.renderItem,
          keygen = _ref3.keygen,
          _ref3$colNum = _ref3.colNum,
          colNum = _ref3$colNum === void 0 ? (cov_tmgv87zz2.b[17][0]++, DefaultProps.colNum) : _ref3$colNum;

      var _ref4 = (cov_tmgv87zz2.s[38]++, this.state),
          currentIndex = _ref4.currentIndex,
          fixed = _ref4.fixed;

      var scrollHeight = (cov_tmgv87zz2.s[39]++, this.getScrollHeight());
      var ms = (cov_tmgv87zz2.s[40]++, Object.assign({}, style, (cov_tmgv87zz2.b[18][0]++, height) && (cov_tmgv87zz2.b[18][1]++, {
        height: height
      })));
      var start = (cov_tmgv87zz2.s[41]++, currentIndex * colNum);
      var items = (cov_tmgv87zz2.s[42]++, data.slice(start, (currentIndex + itemsInView) * colNum).map(function (d, i) {
        cov_tmgv87zz2.f[6]++;
        cov_tmgv87zz2.s[43]++;
        return (
          /*#__PURE__*/
          React.createElement(Fragment, {
            key: getKey(d, keygen, i),
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 119,
              columnNumber: 22
            }
          }, renderItem(d, i + start))
        );
      }));
      var fr = (cov_tmgv87zz2.s[44]++, Array(colNum).fill('1fr').join(' '));
      var gridStyle = (cov_tmgv87zz2.s[45]++, colNum > 1 ? (cov_tmgv87zz2.b[19][0]++, {
        display: 'grid',
        gridTemplateColumns: fr
      }) : (cov_tmgv87zz2.b[19][1]++, {}));
      cov_tmgv87zz2.s[46]++;
      return (
        /*#__PURE__*/
        React.createElement(Scroll, {
          stable: true,
          className: className,
          style: ms,
          scroll: fixed,
          onScroll: this.handleScroll,
          scrollHeight: scrollHeight,
          scrollTop: this.state.scrollTop,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 125,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: function ref(el) {
            cov_tmgv87zz2.f[7]++;
            cov_tmgv87zz2.s[47]++;
            _this2.optionInner = el;
          },
          style: gridStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 134,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            height: currentIndex * lineHeight,
            gridColumnEnd: '-1'
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 140,
            columnNumber: 11
          }
        }), items))
      );
    }
  }]);

  return LazyList;
}(PureComponent);

LazyList.defaultProps = DefaultProps;
export default LazyList;